import {
  Box,
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Dialog as MuiDialog,
  Select,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import { format } from 'date-fns';
import React, { FunctionComponent } from 'react';

import { usePaymentDialog } from './usePaymentDialog';

interface PaymentDialogProps {
  open: boolean;
  onClose: () => void;
  eventId: string;
  userId: string;
}

export const PaymentDialog: FunctionComponent<PaymentDialogProps> = ({
  open,
  onClose,
  eventId,
  userId,
}) => {
  const {
    isNoAlcool,
    onNoAlcoolChange,
    onSubmit,
    milestone,
    milestones,
    onMilestoneChange,
    numberOfDaysOptions,
    numberOfDays,
    onNumberOfDaysChange,
    arrivalDay,
    onArrivalDayChange,
    arrivalDayOptions,
    getDayNameByDay,
  } = usePaymentDialog(eventId, userId, onClose);
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Valider un paiement</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Valider le paiement de cet utilisateur ?
        </DialogContentText>

        {numberOfDaysOptions.length > 1 ? (
          <Box sx={{ mx: 1, mb: 2 }}>
            <ToggleButtonGroup
              color="secondary"
              exclusive
              onChange={(_, value) => onNumberOfDaysChange(value)}
              value={numberOfDays}
              defaultValue={0}
            >
              {numberOfDaysOptions.map((day) => (
                <ToggleButton key={day} value={day}>
                  {day + 1} soir{day > 0 ? 's' : ''}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
        ) : null}
        {numberOfDays < (milestone?.prices ?? []).length - 1 ? (
          <Box sx={{ mx: 1, mb: 2 }}>
            <ToggleButtonGroup
              color="secondary"
              exclusive
              onChange={(_, value) => onArrivalDayChange(value)}
              value={arrivalDay}
              defaultValue={0}
            >
              {arrivalDayOptions.map((day) => (
                <ToggleButton key={day} value={day}>
                  {`Arriver le ${getDayNameByDay(day)}`}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
        ) : null}

        <Box display="flex" flexDirection="row" alignItems="center">
          <Checkbox
            disabled={!milestone?.noAlcoholDiscount}
            checked={isNoAlcool}
            onChange={onNoAlcoolChange}
          />
          <Typography>Bachus troué</Typography>
        </Box>
        <Typography>Palier</Typography>
        {milestones.length > 0 ? (
          <Select value={milestone?.id ?? ''} onChange={onMilestoneChange}>
            {milestones.map((milestone) => (
              <MenuItem key={milestone.id} value={milestone.id}>
                {`${milestone.name} : ${format(milestone.startAt, 'dd/MM')} -> ${format(milestone.endAt, 'dd/MM')}  (${milestone.prices.map((price) => `${price.day + 1}j : ${price.value / 100}€`).join(', ')}, BT: -
                ${milestone.noAlcoholDiscount && milestone.noAlcoholDiscount > 0 ? `${(milestone.noAlcoholDiscount ?? 0) / 100}€` : ''} 
                ${
                  milestone.bedroomValue && milestone.bedroomValue > 0
                    ? `, Chambre : +${milestone.bedroomValue / 100}€`
                    : ''
                }
                )`}
              </MenuItem>
            ))}
          </Select>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <Button onClick={onSubmit} autoFocus>
          Valider
        </Button>
      </DialogActions>
    </MuiDialog>
  );
};
